import {
  Swords,
  Shield,
  Target,
  Flame,
  ArrowUpFromLine,
} from 'lucide-react';
import { sanitizeMarathiText, looksLikeEncodingCorruption } from '../utils/marathiText';

/** Weapon category flyout icons (desktop + mobile). */
export const weaponNavCategories = [
  { id: 1, code: 'edged', labelKey: 'weapons.categories.edged', Icon: Swords, color: 'text-red-600' },
  { id: 2, code: 'piercing', labelKey: 'weapons.categories.piercing', Icon: ArrowUpFromLine, color: 'text-orange-600' },
  { id: 3, code: 'projectile', labelKey: 'weapons.categories.projectile', Icon: Target, color: 'text-amber-700' },
  { id: 4, code: 'firearms', labelKey: 'weapons.categories.firearms', Icon: Flame, color: 'text-stone-700' },
  { id: 5, code: 'defensive', labelKey: 'weapons.categories.defensive', Icon: Shield, color: 'text-blue-700' },
];

export function findWeaponCategoryById(id) {
  return weaponNavCategories.find((c) => c.id === Number(id)) ?? null;
}

/** Prefer i18n label for known categories; repair garbled API text otherwise. */
export function resolveWeaponCategoryLabel(categoryId, apiLabel, t) {
  const meta = findWeaponCategoryById(categoryId);
  if (meta && t) return t(meta.labelKey);
  const label = String(apiLabel ?? '').trim();
  if (!label || looksLikeEncodingCorruption(label)) {
    return meta && t ? t(meta.labelKey) : sanitizeMarathiText(label);
  }
  return sanitizeMarathiText(label);
}

/** Hub grid: always the five canonical categories with proper Marathi labels. */
export function buildWeaponCategoryHubList(categoriesFromApi, t) {
  return weaponNavCategories.map((nav) => {
    const fromApi = (categoriesFromApi || []).find((c) => c.id === nav.id);
    return {
      id: nav.id,
      categoryName: t(nav.labelKey),
      categoryDescription: fromApi?.categoryDescription
        ? sanitizeCategoryDescription(fromApi.categoryDescription)
        : '',
      active: fromApi?.active !== false,
    };
  });
}

function sanitizeCategoryDescription(text) {
  return sanitizeMarathiText(text);
}

export function getCategoryIcon(code) {
  const cat = weaponNavCategories.find((c) => c.code === code);
  return cat?.Icon ?? Swords;
}
